import { withTranslation } from '@application/i18n/with_translation';
import { Accordion, Flex, Spacer, Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { ReceptionList } from './_reception_list.component';
import { ReceptionBrowserCategoryModel } from './browse_receptions.controller';

interface ReceptionCategoriesProps {
	categories: ReceptionBrowserCategoryModel[];
	root?: boolean;
}

export function ReceptionCategories({ categories, root = true }: ReceptionCategoriesProps) {
	if (categories.length === 0) {
		return null;
	}

	if (root) {
		return (
			<Flex gap={tokens.spacing.x4}>
				{categories.map((category) => (
					<Flex gap={tokens.spacing.x1} key={category.unitId}>
						<Text variant='headingXSmall'>{category.name}</Text>
						<ReceptionList receptions={category.receptions} />
						<ReceptionCategories categories={category.childCategories} root={false} />
					</Flex>
				))}
			</Flex>
		);
	}

	return (
		<Flex gap={tokens.spacing.x1}>
			{categories.map((category) => (
				<Accordion.Root key={category.unitId} type='single' collapsible>
					<Accordion.Item
						header={
							<Flex gap={tokens.spacing.x0_5}>
								<Text variant='labelSemiBold'>{category.name}</Text>
								<Text variant='labelXSmallRegular'>
									{category.numberOfListableChildren === 1
										? withTranslation('View.FindReception.BrowseReceptions.ReceptionCount.Singular')
										: withTranslation('View.FindReception.BrowseReceptions.ReceptionCount.Plural', {
												count: `${category.numberOfListableChildren}`,
											})}
								</Text>
							</Flex>
						}
						value='category.name'
					>
						<Spacer vertical={tokens.spacing.x1} horizontal={tokens.spacing.x1}>
							<ReceptionList receptions={category.receptions} />
							<ReceptionCategories categories={category.childCategories} />
						</Spacer>
					</Accordion.Item>
				</Accordion.Root>
			))}
		</Flex>
	);
}
